/** Hersteller, deren Farben über den Englisch-Dekor-Shop („ED“) abgeglichen werden. */
export const ENGLISCH_HERSTELLER_SCHLUESSEL = ["englisch-dekor-handelsgmbh-co-kg"];
export function istEnglischHersteller(schluessel) {
    return ENGLISCH_HERSTELLER_SCHLUESSEL.includes(schluessel);
}
//# sourceMappingURL=englisch.js.map